import { AuthState } from '@okta/okta-auth-js';

import { FuturesTradeAccountsSummaries } from '../../services/backend/FuturesTradeAccountsSummaries';
import { useBaseApiClient } from '../useBaseApiClient';

export const useFuturesTradeAccountsSummaries: () => FuturesTradeAccountsSummaries<AuthState> =
  () => {
    return useBaseApiClient(FuturesTradeAccountsSummaries);
  };
